import { useAIHubEnabled } from '@office-start/ai-hub-config-service';
import { useCapabilities } from '@office-start/capabilities-service';
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useFeatureGates } from '@office-start/feature-gates-service';
import { useLocStrings } from '@office-start/loc-service';
import { OfficeWorkload } from '@office-start/officehome-types';
export var useNovaGraphQLQuery = function (tileData, pinTile, unpinTile, movePinnedTile) {
    var _a, _b, _c, _d, _e, _f;
    var locStrings = useLocStrings().data;
    var capabilities = useCapabilities().data;
    var context = useOfficeComponentContext().data;
    var enableAIHub = useAIHubEnabled();
    var featuregates = (_a = useFeatureGates()) === null || _a === void 0 ? void 0 : _a.data;
    var enableVisualRefresh = (_c = (_b = featuregates === null || featuregates === void 0 ? void 0 : featuregates.result.visualRefreshGates) === null || _b === void 0 ? void 0 : _b.visualRefreshEnabled) !== null && _c !== void 0 ? _c : false;
    var copilotCoreAppsUsageEnabled = (_f = (_e = (_d = featuregates === null || featuregates === void 0 ? void 0 : featuregates.result) === null || _d === void 0 ? void 0 : _d.copilotGates) === null || _e === void 0 ? void 0 : _e.copilotCoreAppsUsageEnabled) !== null && _f !== void 0 ? _f : false;
    var filteredTileData = tileData;
    // If we are in the v3 AI Hub route, do not return pinned apps in the response to the app bar query
    if (enableAIHub) {
        filteredTileData.m365Apps.edges = tileData.m365Apps.edges.filter(function (edge) {
            var isPinnable = edge.node.isPinnable;
            return isPinnable === false;
        });
    }
    var useQuery = function (query, _variables, _options) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var results = { data: undefined };
        if (query.kind === 'Document') {
            query.definitions.forEach(function (definition) {
                if (definition.kind === 'OperationDefinition') {
                    if (definition.name) {
                        switch (definition.name.value) {
                            case 'AppBarQuery':
                                results = {
                                    data: filteredTileData,
                                };
                                break;
                            case 'AppBarControlQuery':
                                results = {
                                    data: {
                                        views: {
                                            appBarControl: {
                                                id: 'AppBarControl',
                                                rootNavigationAriaLabel: '',
                                                animateSelection: true,
                                                flyoutIcon: {
                                                    __typename: 'InternalIcon',
                                                    name: !!(capabilities === null || capabilities === void 0 ? void 0 : capabilities.appBarOverflowOnlyEnabled)
                                                        ? 'MoreIcon'
                                                        : 'AppsIcon',
                                                },
                                                flyoutIconSelected: {
                                                    __typename: 'InternalIcon',
                                                    name: !!(capabilities === null || capabilities === void 0 ? void 0 : capabilities.appBarOverflowOnlyEnabled)
                                                        ? 'MoreIconSelected'
                                                        : 'AppsIconSelected',
                                                },
                                                enableAIHub: enableAIHub,
                                                enableBrandLogo: enableVisualRefresh,
                                                enableVisualRefreshStyles: enableVisualRefresh,
                                                enableMicaV2WebStyles: !!(capabilities === null || capabilities === void 0 ? void 0 : capabilities.appBarMicaStylesEnabled),
                                                tileBehavior: {
                                                    transparent: !!(capabilities === null || capabilities === void 0 ? void 0 : capabilities.appBarMicaStylesEnabled) ||
                                                        enableVisualRefresh,
                                                    shouldRemoveLockedAppsFromPinnedApps: copilotCoreAppsUsageEnabled,
                                                    shouldShowLabel: true,
                                                    pinningEnabled: !!(capabilities === null || capabilities === void 0 ? void 0 : capabilities.appBarPinningEnabled),
                                                    dragDropEnabled: !!(capabilities === null || capabilities === void 0 ? void 0 : capabilities.appBarDragDropEnabled),
                                                    tileContextMenu: {
                                                        openInNewTabItemLabel: (context === null || context === void 0 ? void 0 : context.workload) ===
                                                            OfficeWorkload.Hwa
                                                            ? locStrings === null || locStrings === void 0 ? void 0 : locStrings.appBarResources.openInBrowser
                                                            : locStrings === null || locStrings === void 0 ? void 0 : locStrings.appBarResources.openInNewTab,
                                                        aboutAppItemLabel: locStrings === null || locStrings === void 0 ? void 0 : locStrings.appBarResources.aboutApp,
                                                        unpinAppItemLabel: locStrings === null || locStrings === void 0 ? void 0 : locStrings.appBarResources.unpinApp,
                                                        pinAppItemLabel: locStrings === null || locStrings === void 0 ? void 0 : locStrings.appBarResources.pinApp,
                                                        uninstallAppItemLabel: locStrings === null || locStrings === void 0 ? void 0 : locStrings.appBarResources.uninstallApp,
                                                    },
                                                    platformAppCommands: {
                                                        aboutCommandEnabled: !!(capabilities === null || capabilities === void 0 ? void 0 : capabilities.m365AppsAboutEnabled),
                                                        uninstallCommandEnabled: !!(capabilities === null || capabilities === void 0 ? void 0 : capabilities.sharedServicesEnabled),
                                                    },
                                                },
                                                appAcquisitionLinkBehavior: {
                                                    linkFormat: 'IconText',
                                                },
                                                localizedStrings: {
                                                    flyoutButtonText: !!(capabilities === null || capabilities === void 0 ? void 0 : capabilities.appBarOverflowOnlyEnabled)
                                                        ? undefined
                                                        : locStrings === null || locStrings === void 0 ? void 0 : locStrings.appBarResources.flyoutButtonText,
                                                    flyoutButtonTitle: locStrings === null || locStrings === void 0 ? void 0 : locStrings.appBarResources.viewMoreApps,
                                                    flyoutEmptyStateMessage: locStrings === null || locStrings === void 0 ? void 0 : locStrings.appBarResources.noAppsYet,
                                                },
                                            },
                                        },
                                    },
                                };
                                break;
                            case 'EnableAIHub':
                                results = {
                                    data: enableAIHub,
                                };
                                break;
                        }
                    }
                }
            });
        }
        return results;
    };
    var useMutation = function (mutationQuery) {
        var mutation = function (options) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var results = { data: undefined };
            if (mutationQuery.kind === 'Document') {
                mutationQuery.definitions.forEach(function (definition) {
                    if (definition.kind === 'OperationDefinition' &&
                        definition.name) {
                        switch (definition.name.value) {
                            case 'AppBarPinAppMutation':
                                results.data = pinTile(options.variables['applicationID']);
                                break;
                            case 'AppBarUnpinAppMutation':
                                results.data = unpinTile(options.variables['applicationID']);
                                break;
                            case 'AppBarMovePinnedAppMutation':
                                results.data = movePinnedTile(options.variables['applicationID'], options.variables['newPinnedIndex']);
                                break;
                        }
                    }
                });
            }
            return new Promise(function () {
                return results;
            });
        };
        var tuple = [
            mutation,
            false /* not loading */,
        ];
        return tuple;
    };
    return {
        useLazyLoadQuery: useQuery,
        useMutation: useMutation,
    };
};
//# sourceMappingURL=useNovaGraphQLQuery.js.map